import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../common/redux/store';
import { DEFAULT_SEARCH_VALUE } from './constant';
import { IPolicySearchParams, IPolicySearchState } from './interface';

const initialState: IPolicySearchState = {
  searchValue: DEFAULT_SEARCH_VALUE,
  listIdDelete: [],
  showPopup: false,
};

export const listPolicyReducer = createSlice({
  name: 'listPolicy',
  initialState: initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<IPolicySearchParams>) {
      state.searchValue = action.payload;
    },
    setListIdDelete(state, action: PayloadAction<number[]>) {
      state.listIdDelete = action.payload;
    },
    setShowPopup(state, action: PayloadAction<boolean>) {
      state.showPopup = action.payload;
    },
  },
});

export const { setSearchValue, setListIdDelete, setShowPopup } =
  listPolicyReducer.actions;

export const searchValue = (state: RootState) => state.listPolicy.searchValue;
export const listIdDelete = (state: RootState) => state.listPolicy.listIdDelete;
export const showPopup = (state: RootState) => state.listPolicy.showPopup;

export default listPolicyReducer.reducer;
